



























































import GetGroupQuery from '@/graphql/queries/getGroup.gql';
import GetGroupTreeQuery from '@/graphql/queries/getGroupTree.gql';
import request from '@/graphql/request';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import DeviceInfoDisplay from '@/components/DeviceInfoDisplay.vue';
import AddDevice from '@/components/AddDevice.vue';
import IDevice from '@/interfaces/device';
import { IGroup, IGroupTreeItem } from '@/interfaces/group';
import { IUser } from '../../interfaces/user';

@Component({
  components: {
    DeviceInfoDisplay,
    AddDevice,
  },
})
export default class ManageGroup extends Vue {
  public group: IGroup | null = null;
  public groupTreeItems: IGroupTreeItem[] = [];

  public get activeRoute() {
    return this.$route.name;
  }

  public get groupId() {
    return this.$route.params.id;
  }

  public get user(): IUser {
    return this.$store.getters.user;
  }

  public get parentGroups(): IGroupTreeItem[] {
    if (!this.groupTreeItems || !this.groupTreeItems.length || !this.group) {
      return [];
    }

    const getParents = (id?: string): IGroupTreeItem[] => {
      if (!id) {
        return [];
      }

      const node = this.groupTreeItems.find(t => t.id === id);
      if (!node || !node.parentId) {
        return [];
      }
      
      const parent = this.groupTreeItems.find(t => t.id === node.parentId);
      if (parent) {
        return [...getParents(parent.id), parent];
      } else {
        return [];
      }
    }
    
    return getParents(this.groupId);
  }

  public mounted() {
    this.refreshGroup();
  }

  public getChildUrl(child: string) {    
    return `/group/${this.groupId}/${child}`;
  }

  @Watch('$route')
  public async refreshGroup() {
    const { data } = await request(GetGroupQuery, { id: this.groupId });
    this.group = data.getGroup;

    if (this.user.role === 'admin') {
      const { data: treeData } = await request(GetGroupTreeQuery);
      this.groupTreeItems = treeData.getGroupTree;
    }
  }
}
